var standardModern = function () {
  function initSlider() {
    var sliderModernEl = document.querySelectorAll(".slider-modern");
    if (!sliderModernEl.length) return;
    var slider = tns({
      container: ".slider-modern",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 400,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayButtonOutput: false,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev",
      nextButton: ".next",
      navAsThumbnails: true,
      responsive: {
        576: {
          items: 1,
          gutter: 10,
          edgePadding: 50,
        },
        768: {
          items: 2,
          edgePadding: 0,
        },
        1200: {
          items: 3,
        },
      },
    });
  }

  function stickyScrollWithOffset(columnSelector, parentSelector) {
    const column = document.querySelector(columnSelector);
    const parent = document.querySelector(parentSelector);

    if (!column || !parent) return;

    const stopOffset = 250;

    const onScroll = () => {
      const { top: parentTop, height: parentHeight } = parent.getBoundingClientRect();
      const { height: columnHeight } = column.getBoundingClientRect();

      if (parentTop < 0 && Math.abs(parentTop) + columnHeight + stopOffset < parentHeight) {
        column.style.position = 'fixed';
        column.style.top = '1px';
      } else if (Math.abs(parentTop) + columnHeight + stopOffset >= parentHeight) {
        column.style.position = 'absolute';
        column.style.top = `${parentHeight - columnHeight - stopOffset}px`;
      } else {
        column.style.position = 'absolute';
      }
    };

    window.addEventListener('load', () => {
      window.scrollBy(0, 1);
      onScroll();
    });

    window.addEventListener('scroll', onScroll);
  }

  function hideElementsIfUrlContains(keyword, selector, className) {
    if (window.location.href.includes(keyword)) {
      const elementsToHide = document.querySelectorAll(selector);
      elementsToHide.forEach(element => {
        element.classList.add(className);
      });
    }
  }

  function stickyScrollWithOffsetArticle(columnSelector, parentSelector) {
    const column = document.querySelector(columnSelector);
    const parent = document.querySelector(parentSelector);

    if (!column || !parent) return;

    const stopOffset = 150;

    const onScroll = () => {
      const { top: parentTop, height: parentHeight } = parent.getBoundingClientRect();
      const { height: columnHeight } = column.getBoundingClientRect();

      if (parentTop < 0 && Math.abs(parentTop) + columnHeight + stopOffset < parentHeight) {
        column.style.position = 'fixed';
        column.style.top = '300px';
      } else if (Math.abs(parentTop) + columnHeight + stopOffset >= parentHeight) {
        column.style.position = 'absolute';
        column.style.top = `${parentHeight - columnHeight - stopOffset}px`;
      } else {
        column.style.position = 'absolute';
        column.style.top = '100px';
      }
    };

    window.addEventListener('load', () => {
      window.scrollBy(0, 1);
      onScroll();
    });

    window.addEventListener('scroll', onScroll);
  }
  
  function tippsParagraph() {
    document.querySelectorAll('p').forEach(p => {
        const firstSpan = p.querySelector('strong:first-of-type');
        if (firstSpan && firstSpan.textContent.includes("Bello's Tipp:")) {
            p.classList.add('tipps-p');
        }
    });
}

function removeEmptyParagraphs() {
  var paragraphs = document.querySelectorAll('p');
  
  paragraphs.forEach(function(p) {
    if (p.textContent.trim() === "") {
      p.parentNode.removeChild(p);
    }
  });
}

  function initBlogSlider() {
    var sliderModernEl = document.querySelectorAll(".slider-modern-blog");
    if (!sliderModernEl.length) return;
    var slider = tns({
      container: ".slider-modern-blog",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 600,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayButtonOutput: false,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev-blog",
      nextButton: ".next-blog",
      navAsThumbnails: true,
      responsive: {
        576: {
          items: 2,
          gutter: 10,
          edgePadding: 50,
        },
        768: {
          items: 3,
          edgePadding: 0,
        },
        900: {
          items: 3,
          edgePadding: 10,
        },
        1200: {
          items: 4,
          edgePadding: 0,
        },
      },
    });
  }

  function initBoxSlider() {
    var sliderModernEl = document.querySelectorAll(".slider-modern-box");
    if (!sliderModernEl.length) return;
    var slider = tns({
      container: ".slider-modern-box",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 600,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayButtonOutput: false,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev-blog",
      nextButton: ".next-blog",
      navAsThumbnails: true,
      responsive: {
        576: {
          items: 1,
          gutter: 10,
          edgePadding: 50,
        },
        768: {
          items: 2,
          edgePadding: 0,
        },
        900: {
          items: 2,
          edgePadding: 10,
        },
        1200: {
          items: 3,
          edgePadding: 20,
        },
      },
    });
  }

  function initFreshSlider() {
    var sliderFreshEl = document.querySelectorAll(".slider-modern-fresh");
    if (!sliderFreshEl.length) return;
    var slider = tns({
      container: ".slider-modern-fresh",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 400,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev",
      nextButton: ".next",
      navContainer: ".slider-indicators",
      navAsThumbnails: true,
      edgePadding: 50,
      gutter: 16,
      responsive: {
        576: {
          items: 1,
          gutter: 10,
        },
        768: {
          items: 3,
          gutter: 25,
          edgePadding: 100,
        },
        1200: {
          items: 3,
        },
      },
    });
  }

  function initPartnerSlider() {
    var sliderFreshEl = document.querySelectorAll(".slider-modern-partner");
    if (!sliderFreshEl.length) return;
    var slider = tns({
      container: ".slider-modern-partner",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 400,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev",
      nextButton: ".next",
      navContainer: ".slider-indicators",
      navAsThumbnails: true,
      edgePadding: 50,
      gutter: 16,
      responsive: {
        576: {
          items: 1,
          gutter: 10,
        },
        768: {
          items: 2,
          gutter: 50,
          edgePadding: 100,
        },
        1200: {
          items: 2,
        },
      },
    });
  }

  function initAboutUsSlider() {
    var sliderFreshEl = document.querySelector(".slider-about-us");
    if (!sliderFreshEl) return;

    var slider = tns({
      container: ".slider-about-us",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 800,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev",
      nextButton: ".next",
      navAsThumbnails: true,
      gutter: 16,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
    });
  }

  function initProductSlider() {
    var sliderModernEl = document.querySelectorAll(".product-slider");
    if (!sliderModernEl.length) return;
    var slider = tns({
      container: "#product-slider",
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      autoplayButtonOutput: false,
      autoplay: true,
      speed: 400,
      lazyload: true,
      arrowKeys: true,
      prevButton: ".prev",
      nextButton: ".next",
      navContainer: ".product-slider-thumbnails",
      navAsThumbnails: true,
      startIndex: 2,
    });
  }

  function initBenefitsSlider() {
    var sliderModernEl = document.querySelectorAll(".benefits-slider");
    if (!sliderModernEl.length) return;

    Array.prototype.forEach.call(sliderModernEl, function (sliderEl) {
      var id = sliderEl.dataset.id;

      var slider = tns({
        container: "#benefits-slider-" + id,
        controlsContainer: "#customize-controls-" + id,
        items: 1,
        navContainer: "#slider-indicators-" + id,
        swipeAngle: 45,
        preventScrollOnTouch: "auto",
        speed: 400,
        lazyload: true,
        autoHeight: true,
        speed: 750,
        autoplayTimeout: 0,
      });

      var thumbnails = sliderEl.querySelectorAll(".benefits-thumbnails li");
      Array.prototype.forEach.call(thumbnails, function (thumbnail) {
        thumbnail.addEventListener("click", function (e) {
          e.stopPropagation();
          slider.goTo(thumbnail.dataset.slide);
        });
      });
    });
  }

  function initSimilarProductSlider() {
    var sliderModernEl = document.querySelector(".slider-product-compare");
    if (!sliderModernEl) return;

    var id = sliderModernEl.dataset.id;

    var slider = tns({
      container: "#product-similar",
      controlsContainer: "#customize-controls-" + id,
      items: 1,
      mouseDrag: true,
      swipeAngle: 45,
      preventScrollOnTouch: "auto",
      speed: 400,
      lazyload: true,
      loop: false,
      responsive: {
        1200: {
          items: 2,
          controls: false,
          arrowKeys: false,
          disable: true,
        },
      },
    });
  }

  function handleNavModal() {
    const modal = document.querySelector(".navbar-modal");
    const triggers = document.querySelectorAll(".navbar-toggler");
    const closeButton = document.querySelector(".navbar-close");
    const modalContent = document.getElementById('navigation');

    function toggleModal() {
      modal.classList.toggle("navbar-show-modal");
    }

    triggers.forEach((trigger) =>
      trigger.addEventListener("click", toggleModal)
    );
    closeButton.addEventListener("click", toggleModal);

    modal.addEventListener('click', function (event) {
      if (!modalContent.contains(event.target)) {
        modal.classList.remove('navbar-show-modal');
      }
    });
  }

  function isMobileHeader() {
    var header = document.querySelector(".header");
    if (!header) return;

    var isMobile = window.innerWidth < 1200;

    header.classList.toggle("header-mobile", isMobile);
  }

  function mobileFooterAcc() {
    var footer = document.querySelector(".footer");
    if (!footer) return;

    var mAcc = footer.querySelectorAll(".m-acc");
    if (!mAcc.length) return;

    Array.prototype.forEach.call(mAcc, function (acc) {
      var headline = acc.querySelector("h3");

      headline.addEventListener("click", function (e) {
        acc.classList.toggle("active");
      });
    });
  }

  function scrollToWidget() {
    var widgetBtns = document.querySelectorAll(".product-compare-btn");
    var widget = document.getElementById("product-sub-widget");
    if (!widgetBtns.length || !widget) return;

    Array.prototype.forEach.call(widgetBtns, function (widgetBtn) {
      widgetBtn.addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
          behavior: "smooth",
          left: 0,
          top: widget.offsetTop,
        });
      });
    });
  }

  function openVideoModal() {
    var videoId;

    var videoBTNs = document.querySelectorAll(".btn-video");
    var videoModal = document.getElementById("video-modal");
    var video = document.getElementById("video");

    if (!videoBTNs.length || !videoModal || !video) return;

    Array.prototype.forEach.call(videoBTNs, function (btn) {
      btn.addEventListener("click", function () {
        videoId = btn.dataset.videoId;
      });
    });

    videoModal.addEventListener("shown.bs.modal", function (e) {
      video.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
        videoId +
        "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
      );
    });

    videoModal.addEventListener("hide.bs.modal", function (e) {
      video.setAttribute("src", "");
    });
  }

  function togglePassword() {
    var passwordToggle = document.querySelector(".password-toggle");
    var passwordField = document.querySelector("#CustomerPassword");
    if (!passwordToggle || !passwordField) return;

    passwordToggle.addEventListener("click", function () {
      passwordToggle.classList.toggle("password-toggle-visible");
      if (passwordField.type === "password") {
        passwordField.type = "text";
      } else {
        passwordField.type = "password";
      }
    });
  }

  function hideSpinner() {
    var spinner = document.getElementById("spinner");
    if (!spinner) return;

    spinner.classList.remove("d-none");
  }

  function setupDropdownCloseHandler() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target.closest('.dropdown-area') && document.querySelector('.dropdown-area.open')) {
        document.querySelector('.dropdown-area').classList.remove('open');
      }
    });

    document.querySelector('.dropdown-area').addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  function animation() {
    const counter = document.querySelector("#counter");
    if (!counter) return;

    let req;
    let init = null;
    let time;
    let result;
    const start = 0;
    const end = 2000000;
    const duration = 3000;
    const easing = (t, b, c, d) => (c * t) / d + b; //linear

    const startAnim = (timeStamp) => {
      init = timeStamp;
      draw(timeStamp);
    };

    const draw = (now) => {
      time = now - init;
      result = easing(time, start, end - start, duration);
      result = Math.floor(result);

      const formattedValue = (result >= end ? end : result).toLocaleString(
        "en-US",
        {
          useGrouping: true,
        }
      );

      counter.textContent = formattedValue.replace(/,/g, ".") + " +";

      req = window.requestAnimationFrame(draw);
      time >= duration && window.cancelAnimationFrame(req);
    };

    req = window.requestAnimationFrame(startAnim);
  }

  return {
    init: function () {
      handleNavModal();
      initSlider();
      initBlogSlider();
      initBoxSlider();
      initProductSlider();
      initBenefitsSlider();
      initSimilarProductSlider();
      initFreshSlider();
      initPartnerSlider();
      initAboutUsSlider();
      isMobileHeader();
      mobileFooterAcc();
      scrollToWidget();
      openVideoModal();
      togglePassword();
      animation();
      stickyScrollWithOffset('.scrollable-column', '.parent-container');
      stickyScrollWithOffsetArticle('.scrollable-column-article',  '.article__sidebar');
      hideElementsIfUrlContains('/tagged/', '.hide-on-tagged', 'hide-if-tagged');
      tippsParagraph();
      removeEmptyParagraphs();
    },
    resize: function () {
      isMobileHeader();
    },
    scroll: function () {
    },
    load: function () {
      hideSpinner();
      setupDropdownCloseHandler();
    },
  };
};

var oldFunction = function () {
  return {
    init: function () {
      var acc = document.getElementsByClassName("faq_question");
      var i = void 0;

      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

      var swipers = document.querySelectorAll(".swiper-container");
      if (!swipers.length) return;

      var swiper_two = new Swiper(".swiper-container.two", {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        spaceBetween: 50,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 26,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  };
};

standardModern().init();

window.addEventListener("resize", function () {
  standardModern().resize();
});

window.addEventListener("scroll", function () {
  standardModern().scroll();
});

window.addEventListener("load", function () {
  standardModern().load();
});

oldFunction().init();

window.modernTheme = window.modernTheme || {};
(function () {
  "use strict";

  var helpers = {
    getCookie: function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    },
    setCookie: function (name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  };

  modernTheme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
    trackAddToCartEvents();
    storeInSessionStorage();
    attachDiscountToPetcon();
    updateUnbounceTracking();
    function checkUrlHash() {
      var hash = window.location.hash;
      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }
    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById("RecoverPasswordForm")
        .classList.toggle("hide");
      var loginForm = document
        .getElementById("CustomerLoginForm")
        .classList.toggle("hide");
    }
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById("RecoverPassword");
      if (recoverForm) {
        recoverForm.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        "HideRecoverPasswordLink"
      );
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
    function resetPasswordSuccess() {
      var formState = document.querySelector(".reset-password-success");
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
      // show success message
      document.getElementById("ResetSuccess").classList.remove("hide");
    }
    function customerAddressForm() {
      var newAddressForm = document.getElementById("AddressNewForm");
      var addressForms = document.querySelectorAll(".js-address-form");
      if (!newAddressForm || !addressForms.length) {
        return;
      }
      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll(".js-address-country").forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);
      // Toggle new/edit address forms
      document.querySelectorAll(".address-new-toggle").forEach((el) => {
        el.addEventListener("click", function () {
          newAddressForm.classList.toggle("hide");
        });
      });
      document.querySelectorAll(".address-edit-toggle").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document
            .getElementById("EditAddress_" + formId)
            .classList.toggle("hide");
        });
      });
      document.querySelectorAll(".address-delete").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
          if (
            confirm(
              confirmMessage || "Are you sure you wish to delete this address?"
            )
          ) {
            if (Shopify) {
              Shopify.postLink("/account/addresses/" + formId, {
                parameters: { _method: "delete" },
              });
            }
          }
        });
      });
    }
    function trackAddToCartEvents() {
      if (
        typeof window._tfa === "undefined" ||
        !_tfa ||
        typeof obApi === "undefined"
      )
        return;

      const addToCartButton = document.querySelectorAll(".add-to-cart");
      const startCheckoutBtn = document.querySelectorAll(".cart__checkout");

      addToCartButton.forEach((button) => {
        button.addEventListener("click", () => {
          _tfa.push({ notify: "event", name: "add_to_cart", id: 1368181 });
          obApi("track", "Add to cart Website");
        });
      });

      startCheckoutBtn.forEach((button) => {
        button.addEventListener("click", () => {
          _tfa.push({ notify: "event", name: "Kasse", id: 1368181 });
          obApi("track", "Checkout");
        });
      });
    }
    function storeInSessionStorage() {
      var url = window.location.href;
      var urlObj = new URL(url);
      var int_wgsid = urlObj.searchParams.get("int_wgsid");
      var wgsid = urlObj.searchParams.get("wgsid");
      if (int_wgsid !== null) {
        sessionStorage.setItem("int_wgsid", int_wgsid);
      }
      if (wgsid !== null) {
        sessionStorage.setItem("wgsid", wgsid);
      }
    }
    function attachDiscountToPetcon() {
      setTimeout(function () {
        console.log("Discount Attached");
        var discountCode = helpers.getCookie("discount_code");
        var petconURLs = document.querySelectorAll(".petcon-btn-link");
        var forms = document.querySelectorAll(".petcon-widget-form"); // Select all forms

        if (discountCode && petconURLs.length > 0) {
          petconURLs.forEach(function (petconURL) {
            // Modify href for anchor tags
            if (petconURL.tagName === 'A' && petconURL.href) {
              petconURL.href +=
                (petconURL.href.includes("?") ? "&" : "?") +
                "discount=" +
                discountCode;
            }
          });

          // Update the data-url for each form to include the discount code
          forms.forEach(function (form) {
            var formDataUrl = form.getAttribute("data-url");
            if (formDataUrl) {
              form.setAttribute("data-url", formDataUrl + (formDataUrl.includes("?") ? "&" : "?") + "discount=" + discountCode);
            }
          });
        }
      }, 4000);
    }


    var isUnbounceConversionComplete = false;

    function updateUnbounceTracking() {
      if (!document.referrer || isUnbounceConversionComplete) return;

      var referrerDomain = new URL(document.referrer).hostname;

      if (
        referrerDomain.includes("hellobello") ||
        referrerDomain.includes("hundefutter-ratgeber")
      ) {
        var _ubad = referrerDomain;
        var _ubaq = window._ubaq || [];
        _ubaq.push(["trackGoal"]);

        var ub_script = document.createElement("script");
        ub_script.type = "text/javascript";
        ub_script.src = "//" + _ubad + "/_ub/static/ets/t.js";

        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(ub_script, s);
      }
      isUnbounceConversionComplete = true;
    }
  };

  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    const playButton = document.querySelector('.video-play-button');
    const videoElement = document.querySelector('.video-element');

    if (playButton && videoElement) {
      playButton.addEventListener('click', function () {
        videoElement.play();
        playButton.style.display = 'none';
      });

      videoElement.addEventListener('play', function () {
        playButton.style.display = 'none';
      });

      videoElement.addEventListener('pause', function () {
        playButton.style.display = 'block';
      });
    }

    modernTheme.customerTemplates();
    document.dispatchEvent(new CustomEvent("page:loaded"));
    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
})();
